<app-navbar [navList]="navList" entityName="Contesto" [search]="true"
    [createButton]="!hasMadPermission ? 'hide' : !contestLimitReached ? 'show' : 'disabled'"
    (searchEvent)="searchValue = $event" i18n-searchPlaceholder searchPlaceholder="Cerca per Nome, Descrizione...">
</app-navbar>

<div class="qai-content-box overflow-auto">

    @if(contestLimitReached) {
    <div class="alert alert-warning" role="alert" i18n *ngxPermissionsOnly="['ROLE_MAD']">
        Attenzione: è stato raggiunto il numero massimo di contesti disponibili. Eliminane uno per crearne uno nuovo.
    </div>
    <div class="alert alert-warning" role="alert" i18n *ngxPermissionsOnly="['ROLE_ADM']">
        Attenzione: è stato raggiunto il numero massimo di contesti disponibili. Chiedere al MAD di eliminarne uno per
        crearne uno nuovo.
    </div>
    }

    @if (isLoading) {
    <div class="row g-4">
        @for (fakeloading of [1,2]; track $index) {
        <div class="col-12 col-md-6 col-lg-4">
            <div class="card qai-card p-3" aria-hidden="true">
                <div class="card-body">
                    <p class="card-text placeholder-glow">
                        <span class="placeholder col-3"></span>
                    </p>
                    <h5 class="card-title placeholder-glow">
                        <span class="placeholder col-6"></span>
                        <span class="visually-hidden" i18n>Titolo in caricamento...</span>
                    </h5>
                    <p class="card-text qai-context-description placeholder-glow">
                        <span class="placeholder col-12"></span>
                        <span class="placeholder col-12"></span>
                        <span class="placeholder col-4"></span>
                    </p>
                    <p class="placeholder-glow">
                        <span class="placeholder col-3 bg-primary"></span>
                    </p>
                </div>
            </div>
        </div>
        }
    </div>
    }

    @if (!isLoading && (contexts$ | async)?.length === 0) {
    <app-entity-info [name]="'Contesti'">
        <p class="text-primary mb-2" *ngxPermissionsOnly="['ROLE_ADM']" i18n>
            I contesti rappresentano le knowledge base sulle quali agirà il motore di ricerca. <br />
            Soltanto il Master Admin può creare i contesti e associarli ai gruppi opportuni. <br />
            Come utente Admin, tu vedrai soltanto i contesti associati ai gruppi di cui fai parte.
            Potrai gestire le knowledge base (documenti e siti web) di questi contesti e aggiungere o rimuovere
            documenti dalla knowledge base.
        </p>

        <p class="text-primary mb-2" *ngxPermissionsOnly="['ROLE_MAD']" i18n>
            I contesti rappresentano le knowledge base sulle quali agirà il motore di ricerca. <br />
            In qualità di Master Admin puoi creare i contesti e associarli ai gruppi opportuni. <br />
            Soltanto gli utenti appartenenti ai gruppi associati ai contesti potranno vedere la knowledge base
            (documenti e siti web) <br /> e aggiungere o rimuovere documenti dalla knowledge base.

            <br /><br />
            Per creare un contesto clicca il tasto "CREA CONTESTO" che trovi in alto a destra
        </p>

        <!-- <button type="button" class="mt-4 btn btn-primary te-outline-primary" i18n [routerLink]="'/contexts/new'">
                    Crea Contesto
                </button> -->
    </app-entity-info>
    }

    <div class="row g-4">
        @for (context of getFilteredContexts((contexts$ | async) || []); track context.id) {

        <div class="col-12 col-md-6 col-lg-4">
            <div class="card qai-card te-clickable-card p-3" (click)="openContextDetail(context)" role="button">
                <div class="card-body">
                    <div class="text-muted d-flex align-items-center justify-content-between">
                        <span>{{ context.createDate | date: 'dd/MM/yyyy' }}</span>
                        <div class="d-flex align-items-center">
                            @if (context?.status !== 'COMPLETED') {
                            <span class="badge me-2" [ngClass]="{
                                'qai-bg-danger': context?.status === 'FAILED',
                                'qai-bg-deleted': context?.status === 'IDLE',
                                'qai-bg-secondary': context?.status === 'PENDING'
                              }" style="font-size: 1.1em;">
                                {{ statusTranslationMap[context.status] || context.status }}
                            </span>
                            } @else {
                            <span class="badge" *ngxPermissionsOnly="['ROLE_MAD']" [ngClass]="{
                                'qai-bg-success': context?.integrationStatus === 'FRONTEND_INTEGRATION_ALLOWED',
                                'qai-bg-info': context?.integrationStatus === 'BACKEND_INTEGRATION_ONLY',
                                'qai-bg-secondary': context?.integrationStatus === 'DISABLED',
                              }" style="font-size: 1.1em;">
                                {{ integrationStatusTranslationMap[context.integrationStatus] ||
                                context.integrationStatus }}
                            </span>
                            }
                        </div>
                    </div>
                    <h5>{{ context.name }} <fa-icon [icon]="faArrowRight" size="lg" style="color: #6c757d;"></fa-icon>
                    </h5>
                    <p class="qai-context-description">{{ context.description }}</p>
                    @if (isContextListElem(context) && context.groups && context.groups.length > 0) {
                    <div ngbDropdown class="d-inline-block" (click)="$event.stopPropagation()"
                        *ngxPermissionsOnly="['ROLE_MAD']">
                        <button type="button" class="btn btn-link p-0 link-underline link-underline-opacity-0"
                            id="groupsDropdown" ngbDropdownToggle>
                            {{ context.groups.length }} {{ context.groups.length > 1 ? 'Gruppi' : 'Gruppo' }}
                        </button>
                        <div ngbDropdownMenu aria-labelledby="groupsDropdown">
                            @for (group of context.groups; track group.id) {
                            <button ngbDropdownItem (click)="navigateGroupDetail(group.id)">{{group.name}}</button>
                            }
                        </div>
                    </div>
                    } @else if (!isContextListElem(context)) {
                    <p *ngxPermissionsOnly="['ROLE_ADM']">
                        <span [class.tas-link-color]="context.documentCount > 0" i18n>{{ context.documentCount }}
                            Documenti</span>
                        /
                        <span [class.tas-link-color]="context.urlPatternCount > 0" i18n>{{ context.urlPatternCount }}
                            Siti Web</span>
                    </p>
                    }
                </div>
            </div>
        </div>
        }
    </div>
</div>